import { useMusic } from '~/composables/useMusic'

export default defineNuxtPlugin(() => {
  const music = useMusic()

  // #721: スマホの画面ロック・アプリのバックグラウンド化で BGM を止める。
  // visibilitychange は画面ロック/タブ非表示/アプリ背面化で hidden=true になる
  // 標準シグナル。pauseMusic/resumeMusic は BGM ON/OFF トグル（enabled）とは
  // 独立した pauseRequested フラグで動くので、ユーザーが OFF にしていれば
  // 復帰時も鳴らない（resumeMusic が enabled を尊重する）。
  if (import.meta.client) {
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        music.pauseMusic()
      }
      else {
        music.resumeMusic()
      }
    })
  }

  return {
    provide: {
      music,
    },
  }
})
